import React from 'react';
import {
    Button,
    Grid,
    IconButton,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CustomInput from '../../../../../components/CustomInput';
import { useGetIssueTrackerCategoriesQuery, useGetIssueTrackerPrioritiesQuery } from 'features/IssuesTracker/issuesTrackerSlice';
import { LotTypeEnumList } from 'features/lots/LotsEnums';
import { issueTrackerRuleCriteriaFieldEnum, issueTrackerRuleCriteriaFieldList, ruleOperandsEnum } from '../IssueTrackerConfigConsts';
import { issueTrackerConfigStyles } from '../style';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';


const RuleConditions = ({ ruleToEdit, onFieldChange }) => {
    const classes = issueTrackerConfigStyles();

    let { data: categories, error: categoriesError, isFetching: isLoadingCategories } = useGetIssueTrackerCategoriesQuery();
    let { data: priorities, error: prioritiesError, isFetching: isLoadingPriorities } = useGetIssueTrackerPrioritiesQuery();
    categories = categories || [];
    priorities = priorities || [];

    const issueTrackerRuleCriteriaFieldValues = {
        [issueTrackerRuleCriteriaFieldEnum.Category]: categories || [],
        [issueTrackerRuleCriteriaFieldEnum.LotType]: LotTypeEnumList || [],
        [issueTrackerRuleCriteriaFieldEnum.Priority]: priorities || [],
    }

    const onChangeConditionValue = (item, key, val, index) => {
        let conditions = [...(ruleToEdit?.conditionList ?? [])];
        let newItem = { ...item };
        newItem[key] = val;
        if (key == "field") {
            newItem["value"] = '';
        }
        conditions[index] = { ...newItem };
        onFieldChange("conditionList", conditions);
    }

    const onAddCondition = () => {
        let conditionsList = [...(ruleToEdit?.conditionList ?? [])];
        conditionsList.push({ 'field': null, 'value': null });
        onFieldChange("conditionList", conditionsList);
    }

    const onDeleteCondition = (index) => {
        let conditionsList = [...(ruleToEdit?.conditionList ?? [])];
        conditionsList.splice(index, 1);
        onFieldChange("conditionList", conditionsList);
    }

    // If the operand is "Or", show all fields. If the operand is "And", filter out the fields that are already selected in the conditions.
    const getFilteredRuleTypeList = (conditionField) => {
        let filteredList = issueTrackerRuleCriteriaFieldList.filter(type => {
            return !ruleToEdit?.conditionList?.some(condition => condition.field == type.id);
        });
        if (!!conditionField && !filteredList?.find(type => type.id == conditionField)) {
            filteredList.push(issueTrackerRuleCriteriaFieldList.find(type => type.id == conditionField));
        }
        return filteredList;
    }

    return (
        <>
            {ruleToEdit?.conditionList?.map((condition, i) => <>
                <Grid item xs={3}>
                    <Authorize profile={permissionProfiles.ISSUETRACKER.VIEW_CONFIG}>
                        <CustomInput
                            key={i}
                            label="Field"
                            elementType="dropdown"
                            values={ruleToEdit?.ruleOperand == ruleOperandsEnum.Or ? issueTrackerRuleCriteriaFieldList : getFilteredRuleTypeList(condition?.field)}
                            value={condition?.field}
                            onChange={val => onChangeConditionValue(condition, "field", parseInt(val), i)}
                            showEmpty={true}
                            required
                        />
                    </Authorize>
                </Grid>
                <Grid item xs={3}>
                    <Authorize profile={permissionProfiles.ISSUETRACKER.VIEW_CONFIG}>
                        <CustomInput
                            key={i}
                            label="Value"
                            elementType="dropdown"
                            values={issueTrackerRuleCriteriaFieldValues[condition?.field]}
                            value={condition?.value}
                            onChange={val => onChangeConditionValue(condition, "value", val.toString(), i)}
                            showEmpty={true}
                            required
                        />
                    </Authorize>
                </Grid>
                <Grid item xs={6}>
                    <Authorize profile={permissionProfiles.ISSUETRACKER.SAVE_CONFIG}>
                        <IconButton edge="end" aria-label="delete"
                            onClick={() => onDeleteCondition(i)}
                        >
                            <DeleteOutlineIcon />
                        </IconButton>
                    </Authorize>
                </Grid>
            </>)}
            {(ruleToEdit?.conditionList.length < 3 || ruleToEdit?.ruleOperand == ruleOperandsEnum.Or) &&
                <Authorize profile={permissionProfiles.ISSUETRACKER.SAVE_CONFIG}>
                    <Grid item xs={12}>
                        <Button
                            className={classes.addButton}
                            variant="outlined"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={onAddCondition}
                        >
                            Add Rule Condition
                        </Button>
                    </Grid>
                </Authorize>}
        </>
    );
};

export default RuleConditions;
